import { GET_AGENT_STATUS } from '../queries/agentStatusQueries';
import { GET_CURRENT_USER_CAPACITY_DATA_QUERY, GET_USER_CAPACITY_DATA_QUERY } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/UserCapacityLimitsV2Service.dfc.new';
import { realtimeMessageToResponse } from '../utils/capacityUtils';
export function getCachedAgentStatus(client, workspace) {
  const agentStatusCache = client.readQuery({
    query: GET_AGENT_STATUS,
    variables: {
      workspace: workspace || ''
    }
  });
  return agentStatusCache ? agentStatusCache.agentStatus : undefined;
}
export function updateCachedAgentStatus({
  agentStatus,
  client,
  workspace
}) {
  client.writeQuery({
    query: GET_AGENT_STATUS,
    data: {
      agentStatus
    },
    variables: {
      workspace: workspace || ''
    }
  });
}
export const updateCachedCurrentUserCapacity = (capacityLimitMessage, client) => {
  const messageAsResponse = realtimeMessageToResponse(capacityLimitMessage);
  if (!messageAsResponse) {
    return;
  }
  const currentUserQuery = client.readQuery({
    query: GET_CURRENT_USER_CAPACITY_DATA_QUERY,
    variables: {
      userId: capacityLimitMessage.userId
    }
  });
  if (currentUserQuery) {
    client.writeQuery({
      query: GET_CURRENT_USER_CAPACITY_DATA_QUERY,
      data: {
        result: Object.assign({}, currentUserQuery.result, messageAsResponse)
      }
    });
  }
};
export function updateCachedCapacityLimit({
  capacityLimitMessage,
  client,
  authUserId
}) {
  const messageAsResponse = realtimeMessageToResponse(capacityLimitMessage);
  if (!messageAsResponse) {
    return;
  }
  const userQuery = client.readQuery({
    query: GET_USER_CAPACITY_DATA_QUERY,
    variables: {
      userId: capacityLimitMessage.userId
    }
  });
  if (userQuery) {
    client.writeQuery({
      query: GET_USER_CAPACITY_DATA_QUERY,
      data: {
        result: Object.assign({}, userQuery.result, messageAsResponse)
      },
      variables: {
        userId: capacityLimitMessage.userId
      }
    });
  }
  if (capacityLimitMessage.userId === authUserId) {
    updateCachedCurrentUserCapacity(capacityLimitMessage, client);
  }
}